import { ValuePropsTableCell } from 'shared/valueProps/ValuePropsCell';

/**
 * @param {Object} args
 * @param {(notification: { text: string, level: string }) => void} args.setNotification
 */
const createValuePropColumn = ({ setNotification } = {}) => ({
    accessor: 'valueProps',
    Header: 'Value Prop',
    editable: false,
    // Assigned value props are loaded in the cell (not on the row), so no filterValues —
    // an empty filterValues() would register as an array filter and hide every row.
    Cell: ValuePropsTableCell,
    valuePropCellProps: { setNotification },
});

export { createValuePropColumn };
